import { NativeSelect } from '@chakra-ui/react'
import { CHAMBER_FILTER_ANY, CHAMBER_LABELS, levelFilterValue } from './chamberFilter'
import type { OfficeLevel } from '../../types/lobbyDay'

interface ChamberFilterSelectProps {
  value: string
  onChange: (value: string) => void
  width?: string
  size?: 'xs' | 'sm' | 'md'
  /** Accessible name. Defaults to "Chamber". */
  label?: string
  /** When set, hard-limit the options to that office level's chambers (used by jurisdiction-scoped
   *  surfaces like a lobby-day event's legislator picker): a State event never offers the federal
   *  chambers and vice versa. Omit for the general roster views, which offer both levels. */
  level?: OfficeLevel
}

/** One control for both granularities Andrew asked for: pick a chamber, or pick a whole
 *  office level. Grouped native select so 390px gets the OS picker and a ≥44px target for
 *  free — a second dropdown next to the existing one was rejected as more roster clutter. */
export function ChamberFilterSelect({
  value, onChange, width = '220px', size = 'sm', label = 'Chamber', level,
}: ChamberFilterSelectProps) {
  return (
    <NativeSelect.Root size={size}>
      <NativeSelect.Field
        w={width}
        minH="44px"
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}>
        {level === 'State' ? (
          <>
            <option value={levelFilterValue('State')}>All state legislators</option>
            <option value="StateSenate">{CHAMBER_LABELS.StateSenate}</option>
            <option value="StateHouse">{CHAMBER_LABELS.StateHouse}</option>
          </>
        ) : level === 'Federal' ? (
          <>
            <option value={levelFilterValue('Federal')}>All federal legislators</option>
            <option value="USHouse">{CHAMBER_LABELS.USHouse}</option>
            <option value="USSenate">{CHAMBER_LABELS.USSenate}</option>
          </>
        ) : (
          <>
            <option value={CHAMBER_FILTER_ANY}>All chambers</option>
            <optgroup label="State">
              <option value={levelFilterValue('State')}>All state legislators</option>
              <option value="StateSenate">{CHAMBER_LABELS.StateSenate}</option>
              <option value="StateHouse">{CHAMBER_LABELS.StateHouse}</option>
            </optgroup>
            <optgroup label="Federal">
              <option value={levelFilterValue('Federal')}>All federal legislators</option>
              <option value="USHouse">{CHAMBER_LABELS.USHouse}</option>
              <option value="USSenate">{CHAMBER_LABELS.USSenate}</option>
            </optgroup>
          </>
        )}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  )
}
